import * as Icons from 'lucide-react';
import { X } from 'lucide-react';
import { useState } from 'react';
import useGrandeEcole from '../../stores/useGrandeEcole';

export default function AppMobileNav({ activeSection, onNavigate }) {
  const { layout } = useGrandeEcole();
  const [showMore, setShowMore] = useState(false);
  const order = layout?.sidebarOrder || [];
  const modules = layout?.modules || {};

  // Séparation : les 4 premiers dans la barre, le reste dans "Plus"
  const visibleItems = order.slice(0, 4);
  const moreItems = order.slice(4);

  const getIcon = (iconName) => {
    const IconComponent = Icons[iconName];
    return IconComponent ? <IconComponent size={18} /> : <Icons.Circle size={18} />;
  };

  return (
    <>
      <nav className="md:hidden fixed bottom-0 inset-x-0 border-t border-zinc-800 bg-zinc-900/95 backdrop-blur-md z-50">
        <div className="flex items-center justify-around py-1">
          {visibleItems.map((sectionId) => {
            const meta = modules[sectionId];
            const label = meta?.label?.substring(0, 3) || sectionId.substring(0, 3);
            const iconName = meta?.icon || 'Circle';
            const isActive = activeSection === sectionId;

            return (
              <button
                key={sectionId}
                onClick={() => {
                  setShowMore(false);
                  onNavigate(sectionId);
                }}
                className={`flex flex-col items-center px-2 py-1 text-[9px] uppercase tracking-wider ${
                  isActive ? 'text-orange-400' : 'text-zinc-500'
                }`}
              >
                {getIcon(iconName)}
                <span className="mt-0.5">{label}</span>
              </button>
            );
          })}

          {/* Bouton "Plus" */}
          {moreItems.length > 0 && (
            <button
              onClick={() => setShowMore(!showMore)}
              className={`flex flex-col items-center px-2 py-1 text-[9px] uppercase tracking-wider ${
                showMore ? 'text-orange-400' : 'text-zinc-500'
              }`}
            >
              <Icons.MoreHorizontal size={18} />
              <span className="mt-0.5">Plus</span>
            </button>
          )}
        </div>
      </nav>

      {/* Menu "Plus" en overlay */}
      {showMore && (
        <div className="md:hidden fixed inset-0 z-40 flex flex-col justify-end pb-16 bg-black/60 backdrop-blur-sm" onClick={() => setShowMore(false)}>
          <div
            className="bg-zinc-900 border-t border-zinc-800 px-4 py-4 space-y-1 max-h-64 overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs text-zinc-500 uppercase tracking-widest">Autres sections</span>
              <button onClick={() => setShowMore(false)} className="text-zinc-500 hover:text-white">
                <X size={16} />
              </button>
            </div>
            {moreItems.map((sectionId) => {
              const meta = modules[sectionId];
              const label = meta?.label || sectionId;
              const iconName = meta?.icon || 'Circle';
              const isActive = activeSection === sectionId;

              return (
                <button
                  key={sectionId}
                  onClick={() => {
                    onNavigate(sectionId);
                    setShowMore(false);
                  }}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 text-xs uppercase tracking-wider rounded ${
                    isActive
                      ? 'text-orange-400 bg-orange-950/30'
                      : 'text-zinc-400 hover:bg-zinc-800/50'
                  }`}
                >
                  {getIcon(iconName)}
                  <span>{label}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}